<script>
import ContactEntry from './contact-entry.vue'
import ContactNavbar from './contact-navbar.vue'
import PaginationButtons from '../pagination-buttons.vue'

export default {
  components: {ContactEntry, ContactNavbar, PaginationButtons},

  props: {
    userIds: {type: Array, default: null},
    talkContentCode: {type: String, default: null},
  },

  data() {
    return {
      filter: {},
      contacts: [],
      numContacts: 0,
      perPage: 60,
      numPages: 0,
      page: this.$route.query.page || 1,
      userUuid: this.$storage.getUserUuid(),
      directChannels: [],
    }
  },

  watch: {
    filter: {
      handler(newValue) {
        this.page = 1
        this.fetchContacts(newValue)
        let query = this.filter.search ? {search: this.filter.search} : {}
        this.pushQuery(query)
      },
      deep: true
    },
    page: {
      handler(newValue) {
        this.fetchContacts(this.filter, newValue)
      },
    },
  },

  created() {
    if (this.$route.query.search) {
      this.filter.search = this.$route.query.search
    }
    if (this.userIds) {
      this.filter.uuid = this.userIds
    }
    if (this.talkContentCode) {
      this.filter.talk_code = this.talkContentCode
    }
    this.fetchContacts(this.filter, this.page)
  },

  methods: {
    pushQuery(query) {
      try {
        this.$router.push({query: query})
      } catch(error) {
        console.error(error)
      }
    },

    contactUrl(contact) {
      return `/community/${contact.uuid}`
    },

    onSearchChanged: function (search) {
        this.$set(this.filter, 'search', search)
    },

    fetchContacts: function (filter, page=1) {
      let me =  this
      let params = {page: page, ...this.filter}
      me.$api.get('/community-users/', {params:params}).then(function(response){
        if (me.userUuid)
          me.contacts = response.data.results.filter(contact => contact.uuid !== me.userUuid) || []
        else
          me.contacts = response.data.results
        me.numContacts = me.contacts.length
        me.numPages = response.data.pages
      })
    },
  },
}
</script>

<template>

  <div>
    <contact-navbar v-if="!userIds" class="mb-1"
      :search="filter.search || ''"
      @search="onSearchChanged($event)" 
      @delete-search="filter = {}" 
    />

    <div v-if="numContacts > 0">
      <small class="text-muted me-1">{{numContacts}} Treffer</small>

      <div class="list-group text-deco-none">
        <router-link v-for="contact in contacts" :key="contact.id" :to="contactUrl(contact)" class="text-deco-none">
          <contact-entry :contact="contact" />
        </router-link>
      </div>

      <pagination-buttons :page.sync="page" :num-pages="numPages" />

    </div>
    <div v-else>
      <div class="text-center mt-5">-- keine Treffer --</div>
    </div>

  </div>
</template>

<style scoped>
.text-deco-none {
  text-decoration: none;
}
</style>